import { cn } from "@/utils/cn";

interface OnboardingOptionPillProps {
  label: string;
  selected: boolean;
  onClick: () => void;
  /** Optional 24px leading icon (image URL). */
  icon?: string;
  /** Optional secondary line shown under the label. */
  sublabel?: string;
}

/** Dark selectable answer pill of the v5 onboarding ("Button Pill Tall Selectable Dark" in Figma). */
export const OnboardingOptionPill = ({
  label,
  selected,
  onClick,
  icon,
  sublabel,
}: OnboardingOptionPillProps) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "flex min-h-[52px] w-full items-center gap-2.5 rounded-[40px] border border-white/15 bg-black/10",
      "py-3 pr-4 pl-5 shadow-[inset_0px_-12px_12px_0px_rgba(98,10,213,0.06)] transition-colors",
      selected && "border-white/30",
    )}
  >
    {icon && (
      <span className="flex size-6 shrink-0 items-center justify-center">
        <img src={icon} alt="" className="max-h-6 max-w-6" />
      </span>
    )}
    <span className="flex flex-1 flex-col text-left">
      <span className="text-base leading-6 font-medium text-white">{label}</span>
      {sublabel && <span className="text-xs leading-4 font-medium text-white/50">{sublabel}</span>}
    </span>
    {selected && (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
        aria-hidden
      >
        <path
          d="M4.5 10.5L8.5 14.5L15.5 6.5"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </button>
);
